import React from "react";
import { withStyles, Grid } from "material-ui";

const style = theme => ({
  grid: {
    [theme.breakpoints.down("xs")]:{
      padding: "0 0px !important"
    },
    [theme.breakpoints.down("sm")]:{
      padding: "0 8px"
    },
    [theme.breakpoints.down("md")]:{
      padding: "0 12px"
    },
    padding: "0 15px"
  }
});

function ItemGrid({ ...props }) {
  const { classes, children, ...rest } = props;
  return (
    <Grid item {...rest} className={classes.grid}>
      {children}
    </Grid>
  );
}

export default withStyles(style)(ItemGrid);



// WEBPACK FOOTER //
// ./src/components/Grid/ItemGrid.jsx